import React from 'react';
import clazz from 'classnames';
import QueueAnim from 'rc-queue-anim';
import OverPack from 'rc-scroll-anim/lib/ScrollOverPack';
import { Row, Col } from 'antd';
import styles from './index.module.less';
export default function Partner(props) {
    const { title, source, className, style = {} } = props;
    return (<div className={clazz(styles['parters-wrapper'], className)} style={style}>
      <OverPack playScale={0.15}>
        <QueueAnim type="bottom" key="partner-queue" ease="easeOutQuart" leaveReverse>
          <header>{title}</header>
          <div className={clazz(styles['parters-container'])}>
            <QueueAnim component={Row} type="bottom" key="partner-row">
              {source.map((item, index) => (<Col span={6} key={index} className={clazz(styles['parters-item'])}>
                  <img src={item} alt="#"/>
                </Col>))}
            </QueueAnim>
          </div>
        </QueueAnim>
      </OverPack>
    </div>);
}
